function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M255,22.3H45c-24.9,0-45,20.2-45,45c0,0,0,0,0,0v115.9c0.3,24.8,20.3,44.8,45,45l-1.7,42.4c-0.3,3.6,2.4,6.7,6,7 c2.2,0.2,4.2-0.7,5.6-2.4l39-46.9h161c24.8-0.3,44.8-20.3,45-45V67.5C299.8,42.7,279.8,22.6,255,22.3z M84.8,162.3 c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3s18.3,8.2,18.3,18.3S94.9,162.3,84.8,162.3L84.8,162.3z M149.9,162.3 c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3s18.3,8.2,18.3,18.3S160,162.3,149.9,162.3L149.9,162.3z M215,162.3 c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3c10.1,0,18.3,8.2,18.3,18.3v0C233.2,154.1,225.1,162.3,215,162.3 C214.9,162.3,214.9,162.3,215,162.3L215,162.3z"
});

function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/Icon_Message.fdfbfae5.svg";
export { ForwardRef as ReactComponent };